<template>
    <div :class="[$style.__img__container]">
        <div :class="[$style.__img__item]" v-for="(item, id) in imagesData" v-bind:key="id">
            <div :class="[$style.__img__hover]">
            </div>
             <a :class="['material-icons', $style.__icon]" @click="handleRemoveImage(id)">cancel</a>
            <img :src="item.url">
        </div>
       
    </div>
</template>
<script>
export default {
    props: {
        imagesData: {
            type : Array,
        },
    },
    methods : {
        handleRemoveImage : function (event) {
            this.$emit('parentRemoveImage', event)
        }
    }
}
</script>
<style lang="scss" module scoped>
    .__img__container {
        .__img__item {
            width: auto;
            display : inline-block;
            position: relative;
            margin-right: 10px;
            img {
                width: 50px;
                height: 50px;
            }
            &:hover {
                .__img__hover, .__icon {
                    display: block;
                }
            }
            .__icon {
                position: absolute;
                top: 0; 
                right: 0;
                color : #fff !important;
                display: none;
                cursor: pointer;
            }
            .__img__hover {
                display: none;
                
                background: #000;
                height: 50px;
                position: absolute;
                bottom: 0;
                width: 50px;
                opacity: 0.5;
            }
        }
        margin-bottom : 10px;
    }
</style>